import {
  AdminCreateProcessPayload,
  AdminRunProcessPayload,
} from 'types/Process';
import api from './base/standardApi';

export default {
  getLatest( params?: Record<string, unknown> ) {
    return api.get( 'api/process/latest', params );
  },
  getById( id: string ) {
    return api.get( `api/process/${id}` );
  },
  createAdminProcess( data: AdminCreateProcessPayload, config?: { responseType?: 'blob' } ) {
    return api.post( 'api/process', data, config );
  },
  runAdminProcess( data: AdminRunProcessPayload ) {
    return api.post( 'api/process/run', data );
  },
  getProcessDocuments( id: string ) {
    return api.get( `api/process/${id}/documents` );
  },
  downloadProcessDocument(
    id: string,
    fileName: string,
    options?: { regenerate?: boolean; pdfRenderer?: string },
  ) {
    const params: Record<string, string | boolean> = {};
    if ( options?.regenerate ) params.regenerate = true;
    if ( options?.pdfRenderer ) params.pdfRenderer = options.pdfRenderer;
    return api.get(
      `api/process/${id}/documents/${encodeURIComponent( fileName )}`,
      Object.keys( params ).length ? params : undefined,
      { responseType: 'blob' },
    );
  },
  sendProcessNotifications( id: string ) {
    return api.post( `api/process/${id}/send-notifications`, {} );
  },
};
